module.exports = __webpack_public_path__ + "img/default-profile.69d2ed55.jpg";